import {
  TRAINING_CAMP_PAGE_CHUNK_NAME,
  TRAINING_CAMP_PERSONAL_PAGE_CHUNK_NAME,
} from '@/constants/pageChunk';

export const TrainingCampRouteInfoMixin = {
  name: 'TrainingCampRouteInfoMixin',

  computed: {
    c_isTrainingCampPage() {
      return TRAINING_CAMP_PAGE_CHUNK_NAME === this.$route.name;
    },

    c_isTrainingCampPersonalPage() {
      return TRAINING_CAMP_PERSONAL_PAGE_CHUNK_NAME === this.$route.name;
    },

    c_taskId() {
      return Number(this.$route.params.courseId);
    },
  },
};
